import {
  INTRODUCCIO_INICIALITZAR,
  INTRODUCCIO_OBTENIR_DADES
} from "../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INTRODUCCIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case `${INTRODUCCIO_OBTENIR_DADES}_EN_CURS`:
      return true;

    case `${INTRODUCCIO_OBTENIR_DADES}_SUCCESS`:
    case `${INTRODUCCIO_OBTENIR_DADES}_ERROR`:
      return false;

    default:
      return state;
  }
};

export default peticioEnCurs;

export const getPeticioEnCurs = state => state;
export const getPeticioError = state => state.error;
